export const bindPrototypeMethodsToSelf = (instance, classFn) => {
    const prototype = classFn
        ? classFn.prototype
        : Object.getPrototypeOf(instance);
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props) {
        if (prop === 'constructor' || typeof prototype[prop] !== 'function') {
            continue;
        }
        instance[prop] = prototype[prop].bind(instance);
    }
};
//# sourceMappingURL=class-utils.js.map